import type {GraphQLResponse} from '@github-ui/item-picker-base/api/graphql'
import {parseGraphQLResponse} from '@github-ui/item-picker-base/api/graphql'
import {IssueSingleSelectFieldPickerFieldServerQuery} from '@github-ui/server-persisted-queries'
import type {IssueSingleSelectFieldPickerFieldServerQueryQuery} from '@github-ui/server-persisted-queries/types/IssueSingleSelectFieldPickerFieldServerQuery'
import {reactFetchJSON} from '@github-ui/verified-fetch'

type IssueSingleSelectFieldPickerNode = NonNullable<IssueSingleSelectFieldPickerFieldServerQueryQuery['node']>
type IssueSingleSelectFieldPickerNodeWithOptions = Extract<IssueSingleSelectFieldPickerNode, {options: unknown}>

export type IssueSingleSelectFieldPickerServerOption = IssueSingleSelectFieldPickerNodeWithOptions['options'][number]

export function issueSingleSelectFieldPickerQueryKey(fieldId: string) {
  return ['item-picker', 'issue-single-select-field-options', {fieldId}] as const
}

export async function fetchIssueSingleSelectFieldOptions(
  fieldId: string,
  signal?: AbortSignal,
): Promise<readonly IssueSingleSelectFieldPickerServerOption[]> {
  const params = new URLSearchParams({
    id: fieldId,
    queryId: IssueSingleSelectFieldPickerFieldServerQuery,
  })
  const response = await reactFetchJSON(`/_ghui/item-pickers/issue_single_select_field_options?${params.toString()}`, {
    signal,
  })

  if (!response.ok) throw new Error(`Issue single-select field options fetch failed (${response.status})`)

  const json = (await response.json()) as GraphQLResponse<IssueSingleSelectFieldPickerFieldServerQueryQuery | null> & {
    errors?: Array<{message?: string}>
  }
  const {data} = parseGraphQLResponse(json)
  if (!data) throw new Error('Issue single-select field options query returned no data')

  const node = data.node
  if (node?.__typename === 'IssueFieldSingleSelect') return node.options
  return []
}
